import React from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { cx } from 'cvb';
import PropTypes from 'prop-types';
import { ProPricesStyles } from './ProPrice.style';

const Price = ({ proPrice, regionCode }) => {
  return (
    <div className="pro-prices-icon-container">
      {regionCode === 'cl' ? (
        <div className="pro-prices-icon-cl">
          <p>PRECIO MAYORISTA</p>
        </div>
      ) : (
        <i className="pro-prices-icon-pe" />
      )}
      <div className={cx('pro-prices-badge', regionCode)}>{`sobre ${proPrice?.metadata?.quantityToBuyValue} un`}</div>
      <style jsx>{ProPricesStyles}</style>
    </div>
  );
};

Price.defaultProps = {
  proPrice: {},
  regionCode: 'cl',
};

Price.propTypes = {
  proPrice: PropTypes.object,
  regionCode: PropTypes.string,
};

export default Price;
